module.exports = __webpack_public_path__ + "img/virgin-islands.d746586e.svg";